/* eslint-disable func-names */
/*
 * @Author: cryi.liu
 * @Date: 2020-05-14 11:28:03
 * @LastEditTime: 2020-05-21 17:18:22
 * @Description: 常用工具库
 */
const createObjectURL = (object) => ((window.URL)
  ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object));

const getDateTime = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const hour = date.getHours();
  const minute = date.getMinutes();
  const second = date.getSeconds();
  return `${year}${month}${day}${hour}${minute}${second}`;
};

const debounce = function (func, delay) {
  let timeout;

  return function () {
    clearTimeout(timeout);
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    timeout = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
};

// 是否全屏
function isFullScreen() {
  if (document.fullscreenElement
      || document.mozFullScreenElement
      || document.webkitFullscreenElement
      || document.msFullscreenElement) {
    return true;
  }

  return false;
}

// 全屏
function requestFullScreen(ele) {
  if (!isFullScreen()) {
    if (ele.requestFullscreen) {
      ele.requestFullscreen();
    } else if (ele.mozRequestFullScreen) {
      ele.mozRequestFullScreen();
    } else if (ele.webkitRequestFullScreen) {
      ele.webkitRequestFullScreen();
    } else if (ele.msRequestFullscreen) {
      ele.msRequestFullscreen();
    }
  }
}

// 退出全屏
function exitFullScreen() {
  if (isFullScreen()) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }
}

// 秒数转换
function formatSecond(value) {
  const result = Number.parseInt(value, 10);
  const h = Math.floor(result / 3600) < 10 ? `0${Math.floor(result / 3600)}` : Math.floor(result / 3600);
  const m = Math.floor((result / 60 % 60)) < 10 ? `0${Math.floor((result / 60 % 60))}` : Math.floor((result / 60 % 60));
  const s = Math.floor((result % 60)) < 10 ? `0${Math.floor((result % 60))}` : Math.floor((result % 60));

  let res = '';
  if (h !== '00') res += `${h}:`;
  if (m !== '00') res += `${m}:`;
  res += `${s}`;

  if (m === '00') {
    res = `${m}:${s}`;
  }

  return res;
}

export {
  createObjectURL,
  getDateTime,
  debounce,
  requestFullScreen,
  exitFullScreen,
  isFullScreen,
  formatSecond,
};
